import "./RelatedSearchByTagJsonStyles.scss";
import { cx } from "@emotion/css";
import $ from "jquery";
import { clone, contains, each, map, sortBy, where } from "underscore";
import { applyHoverZoomEffectWrapper, decodeHtml, evenHeights, isNotUndefined, isUndefined } from "../FunctionsCore";
const replaceHtmlEntities = (myJsonObject) => {
    const hits = myJsonObject.hits;
    for (const hit of hits) {
        const desc = hit.description;
        const title = hit.title;
        const author = hit.author;
        const imagePath = hit.imagePath;
        const cta = hit.cta;
        const itemstartPath = hit.itemstartPath;
        const itemendPath = hit.itemendPath;
        hit.description = decodeHtml(desc);
        hit.title = decodeHtml(title);
        hit.author = decodeHtml(author);
        hit.imagePath = decodeHtml(imagePath);
        hit.cta = decodeHtml(cta);
        hit.itemstartPath = decodeHtml(itemstartPath);
        hit.itemendPath = decodeHtml(itemendPath);
    }
};
// TODO Duplication?
const getParameterByName = (parameterName) => {
    const url = window.location.href;
    const nameReplaced = parameterName.replace(/\[]/g, "\\$&");
    const regExp = new RegExp(`[?&]${nameReplaced}(=([^&#]*)|&|#|$)`);
    const results = regExp.exec(url);
    if (results === null) {
        return void 0;
    }
    const resultsThirdElement = results[2];
    if (isUndefined(resultsThirdElement)) {
        return "";
    }
    return window.decodeURIComponent(resultsThirdElement.replace(/\+/g, " "));
};
const relatedSearchByTagJson = (relatedSearchByTagJsonParameter) => {
    $(() => {
        let contentType = "";
        let currentResultLength = 0;
        let filterTag = "";
        let searchItems = [];
        let sortByValue = "most_recent";
        const cleanedJsonRewrittenParsed = relatedSearchByTagJsonParameter.cleanedJsonRewrittenParsed;
        replaceHtmlEntities(cleanedJsonRewrittenParsed);
        const myJsonObjectReplaced = cleanedJsonRewrittenParsed;
        const hitsSortedByDate = myJsonObjectReplaced.hits;
        const hitsSortedByTrending = sortBy(map(hitsSortedByDate, clone), "trendingScore").reverse();
        const hitsSortedByRelevancy = sortBy(map(hitsSortedByDate, clone), "boostTag").reverse();
        let hitsToUse = hitsSortedByDate;
        const $more = $(".more");
        const $relatedSearchByTagJsonSearchResults = $(".relatedSearchByTagJsonSearchResults");
        const $sort = $(".sort");
        const relatedSearchByTagJsonCardWrapper = "relatedSearchByTagJsonCardWrapper";
        const dataRelatedSearchByTagJsonCardWrapperIndex = "data-relatedSearchByTagJsonCardWrapperIndex";
        const getRelatedSearchByTagJsonCardWrapper = () => $(`.${relatedSearchByTagJsonCardWrapper}`);
        // TODO any
        const renderCard = (hit, index) => `
<div class="${relatedSearchByTagJsonCardWrapper} col-md-4 articleitem" ${dataRelatedSearchByTagJsonCardWrapperIndex}="${index}" tabindex="-1">
    ${hit.itemstartPath}

    <div class="row">
        <div class="col-md-12 img">
            ${hit.imagePath}
        </div>

        <div class="col-md-12 text">
            <div class="meta">
                <div class="contenttype_area">
                    <span class="type-text">${hit.contentType}</span>
                </div>

                ${hit.title}
                ${hit.subtitle}

                <span class="credit"></span>

                ${hit.author}

                <span class="date">${hit.date}</span>
                <span class="description">${hit.description}</span>

                ${hit.cta}
            </div>
        </div>
    </div>

    ${hit.itemendPath}
</div>
`;
        // Run when new content type or subcategory is selected,
        // And a new set of filtered articles display
        const filterArticles = () => {
            $relatedSearchByTagJsonSearchResults.html("");
            let searchItemsToUse = [];
            // First gather search results
            if (isNotUndefined(filterTag) && filterTag.length > 0) {
                for (const article of hitsToUse) {
                    if (contains(article.tags, filterTag)) {
                        searchItemsToUse.push(article);
                    }
                }
            }
            else {
                searchItemsToUse = hitsToUse;
            }
            if (isNotUndefined(contentType) && contentType.length > 0) {
                searchItemsToUse = where(searchItemsToUse, { "contentTypeTag": contentType });
            }
            searchItems = searchItemsToUse;
            // Show up to first 6 results
            currentResultLength = searchItems.length >= 6 ? 6 : searchItems.length;
            let index = 0;
            for (const searchItem of searchItems.slice(0, currentResultLength)) {
                $relatedSearchByTagJsonSearchResults.append(renderCard(searchItem, index));
                index += 1;
            }
            $more.toggle(searchItems.length > currentResultLength);
            $(".related_list").each(function () {
                const $this = $(this);
                evenHeights($this, ".contenttype_area");
                evenHeights($this, ".title");
                evenHeights($this, ".author");
                evenHeights($this, ".description");
                evenHeights($this, ".tagline");
            });
        };
        // Give click events to dropdowns
        const changeUserInterfaceAfterClick = ($self, value) => {
            const $parent = $self.parents(".sub_filter_dynamic").find(".select_menu_container");
            const $parentParent = $parent.parent(".sub_filter_dynamic");
            $parentParent.find("li").removeClass("active");
            $parentParent.find("li > span").remove();
            $parentParent.find("li > span.x-img").remove();
            const containerClass = $parentParent.hasClass("subcategory_filter") ? "subcategory_filter" : "contenttype_filter";
            const selfHtml = $self.html();
            // Set on both mobile and desktop versions
            const $child = $parent.find(".select_value").eq(0);
            const $containerClassSelectValue = $(`.${containerClass} .select_value`);
            let action;
            if ($child.data("selectValue") === value) {
                $containerClassSelectValue.data("selectValue", "");
                $containerClassSelectValue.html("");
                action = "clear";
            }
            else {
                $containerClassSelectValue.data("selectValue", value);
                $containerClassSelectValue.html(`: ${selfHtml}`);
                $self.addClass("active");
                $self.prepend('<span class="screen-reader-only">Clear</span>');
                $self.prepend('<span class="x-img"></span>');
                action = "filter";
            }
            return [containerClass, action];
        };
        // Given a subcategory tag or content type tag, change user interface
        const changeUserInterfaceByTag = (tagType, tagValue) => {
            const containerClass = tagType === "subcategory-topics" ? "subcategory_filter" : "contenttype_filter";
            let htmlValue = "";
            const myJsonObjectReplacedTagType = myJsonObjectReplaced[tagType];
            for (const subcategory of myJsonObjectReplacedTagType) {
                if (subcategory["tag-name"] === tagValue) {
                    htmlValue = subcategory["tag-display"];
                }
            }
            // Set on both mobile and desktop versions
            const $selectValue = $(`.${containerClass} .select_value`);
            $selectValue.data("selectValue", tagValue);
            $selectValue.html(`: ${htmlValue}`);
            $(`li[value="${tagValue}"]`).addClass("active");
        };
        const showNextArticleGroup = (amountToShow) => {
            if (currentResultLength < searchItems.length) {
                // If there are more results to display
                const difference = searchItems.length - currentResultLength;
                const resultLength = difference >= amountToShow ? amountToShow + currentResultLength : difference + currentResultLength;
                for (let index = currentResultLength; index < resultLength; index += 1) {
                    // Show up to next 6 results
                    $relatedSearchByTagJsonSearchResults.append(renderCard(searchItems[index], index + currentResultLength));
                }
                currentResultLength = resultLength;
                $more.toggle(searchItems.length > currentResultLength);
            }
        };
        const activateBackClick = () => $relatedSearchByTagJsonSearchResults.on("click", "a", function (cl) {
            cl.preventDefault();
            const $this = $(this);
            const link = $this.attr("href");
            let newHistory = `${window.location.pathname}?`;
            if (isNotUndefined(filterTag) && filterTag.length > 0) {
                newHistory += `filtertag=${filterTag}`;
            }
            if (isNotUndefined(contentType) && contentType.length > 0) {
                newHistory += `&contenttype=${contentType}`;
            }
            if (sortByValue !== "most_relevant") {
                newHistory += `&sort_by=${sortByValue}`;
            }
            if (currentResultLength !== 6) {
                newHistory += `&currlen=${currentResultLength}`;
            }
            const dataRelatedSearchByTagJsonCardWrapperIndexValue = $this.closest(".relatedSearchByTagJsonCardWrapper").attr(dataRelatedSearchByTagJsonCardWrapperIndex);
            newHistory += `&article=${dataRelatedSearchByTagJsonCardWrapperIndexValue}`;
            // eslint-disable-next-line unicorn/no-null
            window.history.pushState(null, "", newHistory);
            if (isNotUndefined(link)) {
                window.location.href = link;
            }
        });
        const clickKeydown = (htmlElement) => {
            const $htmlElement = $(htmlElement);
            $htmlElement.next().toggleClass("active").toggleClass("open");
            const ariaExpanded = $htmlElement.attr("aria-expanded");
            const ariaExpandedNew = ariaExpanded === "true" ? "false" : "true";
            $htmlElement.attr("aria-expanded", ariaExpandedNew);
        };
        $(".the_feed_filter .select_menu_container, .subcategory_filter .select_menu_container, .contenttype_filter .select_menu_container")
            .on("click", function () {
            clickKeydown(this);
        })
            .on("keydown", function () {
            clickKeydown(this);
        });
        $(".subcategory_filter .select_menu_container, .contenttype_filter .select_menu_container").on("keydown", function () {
            $(this).addClass("active");
        });
        $(".select_menu_container")
            .on("mouseover", function () {
            const $this = $(this);
            $this.parent(".contenttype_filter").find(".select_menu_container").addClass("active").attr("aria-expanded", "true");
            $this.parent(".contenttype_filter").find(".select_menu_container").next().addClass("active").addClass("open");
            $this.parent(".subcategory_filter").find(".select_menu_container").addClass("active").attr("aria-expanded", "true");
            $this.parent(".subcategory_filter").find(".select_menu_container").next().addClass("active").addClass("open");
            $this.parent(".the_feed_filter").find(".select_menu_container").attr("aria-expanded", "true");
            $this.parent(".the_feed_filter").find(".select_menu_container").next().addClass("active").addClass("open");
        })
            .on("mouseleave", function () {
            const $this = $(this);
            $this.parent(".contenttype_filter").find(".select_menu_container").removeClass("active").attr("aria-expanded", "false");
            $this.parent(".contenttype_filter").find(".select_menu_container").next().removeClass("active").removeClass("open");
            $this.parent(".subcategory_filter").find(".select_menu_container").removeClass("active").attr("aria-expanded", "false");
            $this.parent(".subcategory_filter").find(".select_menu_container").next().removeClass("active").removeClass("open");
            $this.parent(".the_feed_filter").find(".select_menu_container").attr("aria-expanded", "false");
            $this.parent(".the_feed_filter").find(".select_menu_container").next().removeClass("active").removeClass("open");
        });
        $(".menu")
            .on("mouseover", function () {
            const $this = $(this);
            $this.parent(".the_feed_filter").find(".menu").addClass("open").addClass("active");
            $this.parent(".subcategory_filter").find(".menu").addClass("open").addClass("active");
            $this.parent(".contenttype_filter").find(".menu").addClass("open").addClass("active");
            $this.parent(".the_feed_filter").find(".select_menu_container").attr("aria-expanded", "true");
            $this.parent(".contenttype_filter").find(".select_menu_container").addClass("active").attr("aria-expanded", "true");
            $this.parent(".subcategory_filter").find(".select_menu_container").addClass("active").attr("aria-expanded", "true");
        })
            .on("mouseleave", function () {
            const $this = $(this);
            $this.parent(".the_feed_filter").find(".menu").removeClass("open").removeClass("active");
            $this.parent(".subcategory_filter").find(".menu").removeClass("open").removeClass("active");
            $this.parent(".contenttype_filter").find(".menu").removeClass("open").removeClass("active");
            $this.parent(".the_feed_filter").find(".select_menu_container").attr("aria-expanded", "false");
            $this.parent(".contenttype_filter").find(".select_menu_container").removeClass("active").attr("aria-expanded", "false");
            $this.parent(".subcategory_filter").find(".select_menu_container").removeClass("active").attr("aria-expanded", "false");
        });
        $(".menu li:last-child").on("keydown", function () {
            const $this = $(this);
            $this.parents(".sub_filter").find(".select_menu_container").attr("aria-expanded", "false");
            $this.parent(".menu").removeClass("open");
        });
        $(".contenttype_filter .select_menu_container, .feed_filter_select_container").on("focus", () => {
            $(".topic_dropdown").removeClass("open");
            $(".subcategory_filter .select_menu_container").removeClass("active").attr("aria-expanded", "false");
        });
        $(".subcategory_filter .select_menu_container, .feed_filter_select_container").on("focus", () => {
            $(".content_type_dropdown").removeClass("open");
            $(".contenttype_filter .select_menu_container").removeClass("active").attr("aria-expanded", "false");
        });
        getRelatedSearchByTagJsonCardWrapper()
            .eq(0)
            .on("keydown", () => {
            $(".content_type_dropdown").removeClass("open");
            $(".contenttype_filter .select_menu_container").removeClass("active").attr("aria-expanded", "false");
        });
        $(".feed_filter_select_container.select_menu_container li").on("click", function () {
            const $this = $(this);
            const thisHtml = $this.html();
            const value = $this.attr("name");
            // Refresh selected val
            $this.parents(".select_menu_container").find(".select_value").eq(0).html(thisHtml);
            if (isNotUndefined(value)) {
                window.location.href = value;
            }
        });
        // Add content type dropdown
        const contenttypes = myJsonObjectReplaced["content-types"];
        each(contenttypes, (element) => {
            const elementTagName = element["tag-name"];
            const elems = elementTagName.split(":");
            const tagId = elems[elems.length - 1];
            $(".content_type_dropdown").append($("<li></li>")
                .addClass(cx("di_t", "option", "topics"))
                .attr("id", tagId)
                .attr("role", "option")
                .attr("tabindex", 0)
                .html(element["tag-display"])
                .attr("value", elementTagName));
        });
        // Add topics dropdown
        const subcategorytopics = myJsonObjectReplaced["subcategory-topics"];
        each(subcategorytopics, (element) => {
            const elementTagName = element["tag-name"];
            const elems = elementTagName.split("/");
            const tagId = elems[elems.length - 1];
            $(".topic_dropdown").append($("<li></li>")
                .addClass(cx("di_t", "option", "topics"))
                .attr("id", tagId)
                .attr("role", "option")
                .attr("tabindex", 0)
                .html(element["tag-display"])
                .val(elementTagName));
        });
        const setDefaultSort = () => {
            const firstItem = $(".sort:eq(0)");
            const firstItemId = firstItem.attr("id");
            $sort.removeClass("active");
            firstItem.addClass("active");
            if (firstItemId === "recent") {
                sortByValue = "most_recent";
                hitsToUse = hitsSortedByDate;
            }
            else if (firstItemId === "popular") {
                sortByValue = "most_popular";
                hitsToUse = hitsSortedByTrending;
            }
            else if (firstItemId === "relevant") {
                sortByValue = "most_relevant";
                hitsToUse = hitsSortedByRelevancy;
            }
        };
        $(".sub_filter_dynamic .menu li").on("click", function () {
            const $this = $(this);
            const value = $this.attr("value");
            const results = changeUserInterfaceAfterClick($this, value);
            const containerClass = results[0];
            const action = results[1];
            if (containerClass === "subcategory_filter") {
                // Subcategory menu
                filterTag = action === "filter" ? value : "";
            }
            else {
                // Content type
                contentType = action === "filter" ? value : "";
            }
            filterArticles();
        });
        $more.find(".moreContentButton").on("click", () => {
            showNextArticleGroup(6);
            $(".more .cta").trigger("blur");
            $(getRelatedSearchByTagJsonCardWrapper().toArray().slice(-6)[0]).focus();
            $(".related_list").each(function () {
                const $this = $(this);
                evenHeights($this, ".contenttype_area");
                evenHeights($this, ".title");
                evenHeights($this, ".author");
                evenHeights($this, ".description");
                evenHeights($this, ".tagline");
            });
        });
        $sort.on("click", function () {
            const $this = $(this);
            $sort.removeClass("active");
            $this.addClass("active");
            const sortType = $this.attr("id");
            if (sortType === "popular") {
                hitsToUse = hitsSortedByTrending;
                sortByValue = "most_popular";
            }
            else if (sortType === "recent") {
                hitsToUse = hitsSortedByDate;
                sortByValue = "most_recent";
            }
            else {
                // Default is by relevancy
                hitsToUse = hitsSortedByRelevancy;
                sortByValue = "most_relevant";
            }
            filterArticles();
        });
        activateBackClick();
        setDefaultSort();
        // TODO
        // Const articleId = getParameterByName("article");
        const sortByParameter = getParameterByName("sort_by");
        if (sortByParameter === "most_popular") {
            hitsToUse = hitsSortedByTrending;
            sortByValue = "most_popular";
            $sort.removeClass("active");
            $(".popular").addClass("active");
        }
        else if (sortByParameter === "most_recent") {
            hitsToUse = hitsSortedByDate;
            sortByValue = "most_recent";
            $sort.removeClass("active");
            $(".recent").addClass("active");
        }
        // Once everything is loaded, determine if state needs to be recreated from history
        const contenttypeParameter = getParameterByName("contenttype");
        const filtertagParameter = getParameterByName("filtertag");
        const currlenParameter = getParameterByName("currlen");
        if (isNotUndefined(filtertagParameter) || isNotUndefined(contenttypeParameter)) {
            contentType = isUndefined(contenttypeParameter) ? "" : contenttypeParameter;
            filterTag = isUndefined(filtertagParameter) ? "" : filtertagParameter;
            // Apply filter, change view and show first 6 of filter
            filterArticles();
            if (isNotUndefined(filtertagParameter)) {
                changeUserInterfaceByTag("subcategory-topics", filterTag);
            }
            if (isNotUndefined(contenttypeParameter)) {
                changeUserInterfaceByTag("content-types", contentType);
            }
            // If length was provided, show up to that length
            if (isNotUndefined(currlenParameter)) {
                const amountToShow = window.Number.parseInt(currlenParameter) - 6;
                showNextArticleGroup(amountToShow);
            }
        }
        else {
            currentResultLength = 6;
            searchItems = hitsToUse;
            if (hitsToUse.length > currentResultLength) {
                for (let index = 0; index < 6; index += 1) {
                    const html = renderCard(hitsToUse[index], index);
                    $relatedSearchByTagJsonSearchResults.append(html);
                }
                $more.show();
            }
            //  For search results less than 6
            if (hitsToUse.length <= currentResultLength) {
                for (const [index, element] of hitsToUse.entries()) {
                    const html = renderCard(element, index);
                    $relatedSearchByTagJsonSearchResults.append(html);
                }
                $more.hide();
            }
            // If length was provided, show up to that length
            if (isNotUndefined(currlenParameter)) {
                const amountToShow = window.Number.parseInt(currlenParameter) - 6;
                showNextArticleGroup(amountToShow);
            }
        }
        $(".related_list").each(function () {
            const $this = $(this);
            evenHeights($this, ".contenttype_area");
            evenHeights($this, ".title");
            evenHeights($this, ".author");
            evenHeights($this, ".description");
            evenHeights($this, ".tagline");
        });
        applyHoverZoomEffectWrapper(relatedSearchByTagJsonParameter.applyHoverZoomEffectWrapperParameter);
    });
};
export { relatedSearchByTagJson };
